export class Comment {
  id: number;
  ticketId: number | null;
  name: string;
  content: string;
  constructor(
    id: number,
    ticketId: number | null,
    name: string,
    content: string
  ) {
    this.id = id;
    this.ticketId = ticketId;
    this.name = name;
    this.content = content;
  }

  public static get EMPTY(): Comment {
    return new Comment(0, null, "", "");
  }

  hasValidValue(): boolean {
    return (
      !!this.name &&
      this.name.trim().length > 0 &&
      !!this.content &&
      this.content.trim().length > 0
    );
  }
}
